import MinerDashboard from "@/pages/Miner/Dashboard.vue";
import MinerAdd from "@/pages/Miner/AddWallet.vue";
import MinerEdit from "@/pages/Miner/EditWallet.vue";
import MinerView from "@/pages/Miner/ViewWallet.vue";

import Home from "@/pages/Home.vue";
import Login from "@/pages/Login.vue";
import Register from "@/pages/Register.vue";
import ChangePassword from "@/pages/ChangePassword.vue";
import ChangePasswordLevel2 from "@/pages/ChangePasswordLevel2.vue";
import PanelLeft from "@/pages/PanelLeft";
import NotFound from "@/pages/404.vue";
import MessageCustomer from "@/pages/Message/CustomerList";
import MessageCustomerDetail from "@/pages/Message/CustomerDetail";
import MessageCreate from "@/pages/Message/Create";
import MessageDetail from "@/pages/Message/Detail";
import MessageEdit from "@/pages/Message/Edit";
import CustomerList from "@/pages/Customer/List";
import CustomerCreate from "@/pages/Customer/Create";
import CustomerEdit from "@/pages/Customer/Edit";
import ShortcodeList from "@/pages/Shortcode/List";
import ShortcodeCreate from "@/pages/Shortcode/Create";
import ShortcodeEdit from "@/pages/Shortcode/Edit";
import SetupDisplay from "@/pages/SetupDisplay";
import SetupRegion from "@/pages/SetupRegion";
import SetupStorage from "@/pages/SetupStorage";
import ReportDate from "@/pages/ReportDate";
import ReportDateV2 from "@/pages/ReportDateV2";
import ReportDateV3 from "@/pages/ReportDateV3";
import ReportOver from "@/pages/ReportOver/Report";
import ReportAgent from "@/pages/ReportAgent";
import InboxFriend from "@/pages/Inbox/FriendList";
import InboxChat from "@/pages/Inbox/Chat";
import MentorGenerator from "@/pages/MentorGenerator";
import SecretQuestion from "@/pages/SecretQuestion";
import ForceChangeInformation from "@/pages/ForceChangeInformation";
import ForceChangePassword from "@/pages/ForceChangePassword";
import ForgotPassword from "@/pages/ForgotPassword";
import UserPanel from "@/pages/UserPanel";
import MyProfile from "@/pages/MyProfile";
import MyChilds from "@/pages/MyChilds";
import Wallet from "@/pages/Wallet";
import Transaction from "@/pages/Transaction";
import Maintenance from "@/pages/Maintenance";
import Mission from "@/pages/Mission";
import BuyUsdt from "@/pages/BuyUsdt";
import SimpleAccountCreate from "@/pages/SimpleAccountCreate";

import ReviewRandomNumber from "@/pages/Review/RandomNumber";
import ReviewCalculator from "@/pages/Review/Calculator";

import BotCreate from "@/pages/Inbox/BotCreate";
import BotForwarderCreate from "@/pages/Inbox/BotForwarderCreate";
import BotFreeTextCreate from "@/pages/Inbox/BotFreeCreate";
import BotView from "@/pages/Inbox/BotView";
import BotConfig from "@/pages/Inbox/BotConfig";

import LiveChat from "@/pages/LiveChat.vue";

import { store } from "@/store";

const isLoggedIn = function(routeTo, routeFrom, resolve, reject) {
  if (!store.state.access_token) {
    reject();
    this.app.views.main.router.navigate('/dang-nhap');
  }
  else{
    resolve();
  }
};
/* eslint-disable */
export default [
  {
    path: '/',
    component: MinerDashboard
  },
  {
    path: '/miner/add-wallet',
    component: MinerAdd
  },
  {
    path: '/miner/view-wallet',
    component: MinerView
  },
  {
    path: '/miner/edit-wallet',
    component: MinerEdit
  },
  {
    path: '/review/random-number',
    component: ReviewRandomNumber,
  },
  {
    path: '/review/calculator',
    component: ReviewCalculator,
  },
  {
    path: '/bao-tri',
    component: Maintenance,
  },
  {
    path: '/dang-nhap',
    component: Login,
  },
  {
    path: '/dang-ky',
    component: Register,
  },
  {
    path: '/panel-left/',
    component: PanelLeft
  },
  {
    path: '/dashboard',
    component: Home,
    beforeEnter: isLoggedIn
  },
  {
    path: '/xu-ly/:region/:playStyle/khach-hang/:custId/them-tin-nhan',
    component: MessageCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/xu-ly/:region/:playStyle/khach-hang/:custId/tin-nhan/:messageId',
    component: MessageDetail,
    beforeEnter: isLoggedIn
  },
  {
    path: '/xu-ly/:region/:playStyle/khach-hang/:custId/sua-tin-nhan/:messageId',
    component: MessageEdit,
    beforeEnter: isLoggedIn
  },
  {
    path: '/xu-ly/:region/:playStyle/khach-hang/:custId',
    component: MessageCustomerDetail,
    beforeEnter: isLoggedIn
  },
  {
    path: '/xu-ly/:region/:playStyle',
    component: MessageCustomer,
    beforeEnter: isLoggedIn
  },
  {
    path: '/du-chuan/:region/:playStyle',
    component: ReportOver,
    beforeEnter: isLoggedIn
  },
  {
    path: '/khach-hang',
    component: CustomerList,
    beforeEnter: isLoggedIn
  },
  {
    path: '/khach-hang/tao-moi',
    component: CustomerCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/khach-hang/chi-tiet/:custId',
    component: CustomerEdit,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-mat-khau',
    component: ChangePassword,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-mat-khau-cap-2',
    component: ChangePasswordLevel2,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bao-cao-ngay',
    component: ReportDate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bao-cao-ngay-v2',
    component: ReportDateV2,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bao-cao-ngay-v3',
    component: ReportDateV3,
    beforeEnter: isLoggedIn
  },
  {
    path: '/hoa-hong-gioi-thieu',
    component: ReportAgent,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cu-phap',
    component: ShortcodeList,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cu-phap/tao-moi',
    component: ShortcodeCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cu-phap/chinh-sua',
    component: ShortcodeEdit,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cai-dat-hien-thi',
    component: SetupDisplay,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cai-dat-cach-choi',
    component: SetupRegion,
    beforeEnter: isLoggedIn
  },
  {
    path: '/cai-dat-luu-tru',
    component: SetupStorage,
    beforeEnter: isLoggedIn
  },
  {
    path: '/inbox/danh-sach-ban',
    component: InboxFriend,
    beforeEnter: isLoggedIn
  },
  {
    path: '/inbox/chat',
    component: InboxChat,
    beforeEnter: isLoggedIn
  },
  {
    path: '/tao-ma-gioi-thieu',
    component: MentorGenerator,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-cau-hoi-bao-mat',
    component: SecretQuestion,
    beforeEnter: isLoggedIn
  },
  {
    path: '/ca-nhan',
    component: UserPanel,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-thong-tin-ca-nhan',
    component: MyProfile,
    beforeEnter: isLoggedIn
  },
  {
    path: '/quan-ly-dai-ly',
    component: MyChilds,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-thong-tin-bat-buoc',
    component: ForceChangeInformation,
    beforeEnter: isLoggedIn
  },
  {
    path: '/doi-mat-khau-bat-buoc',
    component: ForceChangePassword,
    beforeEnter: isLoggedIn
  },
  {
    path: '/nap-rut-usdt',
    component: Wallet,
    beforeEnter: isLoggedIn
  },
  {
    path: '/mua-credit',
    component: Transaction,
    beforeEnter: isLoggedIn
  },
  {
    path: '/quen-mat-khau',
    component: ForgotPassword
  },
  {
    path: '/bang-nhiem-vu',
    component: Mission,
    beforeEnter: isLoggedIn
  },
  {
    path: '/mua-usdt',
    component: BuyUsdt,
    beforeEnter: isLoggedIn
  },
  {
    path: '/tao-tai-khoan-khach',
    component: SimpleAccountCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bot/tao-moi',
    component: BotCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bot/tao-moi-ke-tin',
    component: BotForwarderCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bot/tao-moi-nhan-tin',
    component: BotFreeTextCreate,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bot/view',
    component: BotView,
    beforeEnter: isLoggedIn
  },
  {
    path: '/bot/config',
    component: BotConfig,
    beforeEnter: isLoggedIn
  },
  {
    path: '/livechat',
    component: LiveChat
  },
  {
    path: '(.*)',
    component: NotFound,
  }
];
